import aa from "search-insights"

const algoliaAppId = process.env.GATSBY_ALGOLIA_APP_ID
const algoliaAPIKey = process.env.GATSBY_ALGOLIA_API_KEY

const InitializeAlgoliaAnalytics = () => {
  aa("init", {
    appId: algoliaAppId,
    apiKey: algoliaAPIKey,
    useCookie: true,
    cookieDuration: 60 * 60 * 1000, // one hour
  })
}

const getUserToken = () => {
  let userToken

  aa("getUserToken", null, (err, newUserToken) => {
    if (err) {
      console.error(err)
      return
    }
    userToken = newUserToken
  })

  return userToken
}

export { InitializeAlgoliaAnalytics, getUserToken }
